import { ReactNode } from 'react';
import {
  Flex,
  FlexProps,
  Box,
  BoxProps,
  ArrowRightIcon
} from '@blockanalitica/ui';
import styled from 'styled-components';

const Arrow = styled(ArrowRightIcon)`
  display: flex;
  align-self: flex-end;
  color: ${(props) => props.theme.colors.muted};
`;

const Container = styled(Flex)<FlexProps>`
  position: relative;
  height: 100%;
  overflow: hidden;
  border-radius: ${(props) => props.theme.sizes[-1]};
`;

const LeftBackground = styled(Box)<BoxProps>`
  background: radial-gradient(
    100% 177.78% at 100% 0%,
    rgb(162, 115, 255) 0%,
    rgb(67, 49, 233) 100%
  );
  clip-path: polygon(0px 0px, 0px 100%, 58% 100%, 100% 33%, 100% 0px);
  position: absolute;
  height: 100%;
  width: 110%;
`;

const MiddleBackground = styled(Box)<BoxProps>`
  background: linear-gradient(43deg, #f7a7f9 -2.45%, #6d28ff 100%);
  clip-path: polygon(100% 0px, 10% 100%, 0px 100%, 38% 0px);
  position: absolute;
  height: 100%;
  left: 62%;
  width: 138%;
`;

const RightBackground = styled(Box)<BoxProps>`
  background: rgb(42, 25, 125);
  clip-path: polygon(100% 0px, 100% 100%, 0px 100%, 33% 0px);
  position: absolute;
  height: 100%;
  left: 65%;
  width: 200%;
`;

const ContentContainer = styled(Flex)<FlexProps>`
  position: relative;
  z-index: 1;
  line-height: normal;
  padding: ${(props) => props.theme.space.s};
  flex-direction: row;
`;

const StyledLink = styled.a`
  color: inherit;
  display: flex;
  flex: 1;

  transition: 0.25s ease-out;

  &:hover {
    color: inherit;
    scale: 1.02;

    & ${Arrow} {
      color: ${(props) => props.theme.colors.linkHover};
    }
  }
`;

function Wrapper({
  href,
  children
}: {
  href?: string;
  children: ReactNode | ReactNode[];
}) {
  if (href) {
    return (
      <StyledLink href={href} target="_blank">
        {children}
      </StyledLink>
    );
  }
  return <>{children}</>;
}

export default function Banner({
  href,
  children
}: {
  href?: string;
  children: ReactNode | ReactNode[];
}) {
  return (
    <Wrapper href={href}>
      <Container>
        <LeftBackground />
        <MiddleBackground />
        <RightBackground />
        <ContentContainer>
          <Box paddingRight="m">{children}</Box>
          {href ? (
            <Box alignSelf="flex-end">
              <Arrow size="2" />
            </Box>
          ) : null}
        </ContentContainer>
      </Container>
    </Wrapper>
  );
}
